function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, encodeURIComponent, formErrors, formValues, step, waitingForResponse) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['terms-of-use-checkbox'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": {
            display: `flex`
          },
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `terms-of-use`,
              checked: formValues.agreedToTermsOfUse
            }),
            "on": {
              click: $helpers.handleTermsOfUseCheckboxClick
            },
            "class": {
              'signup-checkbox': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-field-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Agreed to ");
              __jade_nodes = __jade_nodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("a", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    href: `/legal/terms-of-use/`,
                    class: `mp-link legal-link`,
                    target: '_blank'
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("terms of use");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this));
              __jade_nodes = __jade_nodes.concat("");;
              return __jade_nodes
            }).call(this));
            __jade_nodes = __jade_nodes.concat((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(" and ");
              __jade_nodes = __jade_nodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("a", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    href: `/legal/privacy-policy/`,
                    class: `mp-link legal-link`,
                    target: '_blank'
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("privacy statements");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this));
              __jade_nodes = __jade_nodes.concat(".");;
              return __jade_nodes
            }).call(this));
            __jade_nodes = __jade_nodes.concat((formErrors.agreedToTermsOfUse) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-error-msg': true
                },
              }, [__vjadeSafeCode(formErrors.agreedToTermsOfUse)]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['department-select'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-field-label': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Department");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `department-select`,
              options: $helpers.DEPARTMENT_OPTIONS,
              'selected-option': formValues.department || `Select department`,
              'validation-status': $helpers.getValidationStatus(`department`),
              'menu-height': 400,
            }),
            "on": {
              change: ev => $helpers.handleDepartmentChange(ev.detail.item)
            },
          }));
          __jade_nodes = __jade_nodes.concat((formErrors.department) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-error-msg': true
              },
            }, [__vjadeSafeCode(formErrors.department)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['promo-checkbox'] = function(shouldShowCheckbox) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((shouldShowCheckbox) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "style": {
              display: `inline-flex`
            },
            "class": {
              'auth-form-field-row': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
              "attrs": __vjadeStringifyAttrsIfObj({
                checked: formValues.agreedToEmailPromo
              }),
              "on": {
                click: $helpers.handleEmailPromoCheckboxClick
              },
              "class": {
                'signup-checkbox': true
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-field-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("I want to understand every user’s journey. Please email me about Mixpanel products and services so I can use data to grow my business. You can always opt out later. See our ");
              __jade_nodes = __jade_nodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("a", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    href: `/legal/marketing-privacy-notice/`,
                    class: `mp-link`,
                    target: '_blank'
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("privacy policy");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this));
              __jade_nodes = __jade_nodes.concat(" for more details.");
              __jade_nodes = __jade_nodes.concat(" ");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['name-input'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `name-input`,
              'field-id': `full-name`,
              label: 'Your name',
              placeholder: `First & Last Name`,
              'validation-status': $helpers.getValidationStatus(`name`),
              'error-message': formErrors.name,
            }),
            "props": {
              value: formValues.name
            },
            "on": {
              input: ev => $helpers.handleFieldInput(ev, `name`),
              blur: ev => $helpers.handleFieldBlur(`name`),
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['email-input'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `email-input`,
              'field-id': `email`,
              label: 'Email Address',
              placeholder: `email@address.com`,
              'validation-status': $helpers.getValidationStatus(`email`),
              'error-message': formErrors.email,
            }),
            "props": {
              value: formValues.email
            },
            "on": {
              input: ev => $helpers.handleFieldInput(ev, `email`),
              blur: ev => $helpers.handleFieldBlur(`email`),
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['password-input'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `password-input`,
              'field-id': `password`,
              type: `password`,
              label: `Password`,
              placeholder: `Password`,
              'validation-status': $helpers.getValidationStatus(`password`),
              'error-message': formErrors.password,
            }),
            "props": {
              value: formValues.password
            },
            "on": {
              input: ev => $helpers.handleFieldInput(ev, `password`),
              blur: ev => $helpers.handleFieldBlur(`password`),
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['continue-button'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `continue-button`,
              size: `large`,
              theme: `primary`,
              disabled: waitingForResponse
            }),
            "on": {
              click: $helpers.handleContinue
            },
            "class": {
              'auth-form-field-action-button': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Get Started");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['company-input'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `company-input`,
              'field-id': `company-name`,
              label: 'Company Name',
              placeholder: `e.g. Acme Inc.`,
              'validation-status': $helpers.getValidationStatus(`company`),
              'error-message': formErrors.company,
            }),
            "props": {
              value: formValues.company
            },
            "on": {
              input: ev => $helpers.handleFieldInput(ev, `company`),
              blur: ev => $helpers.handleFieldBlur(`company`),
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['phone-number'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'field-id': `phone`,
              label: 'Phone Number',
              placeholder: `e.g. 8001110000`,
              necessary: `optional`,
            }),
            "props": {
              value: formValues.phone
            },
            "on": {
              input: ev => $helpers.handleFieldInput(ev, `phone`),
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['company-size-select'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-field-label': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Company Size");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `size-select`,
              options: $helpers.COMPANY_SIZE_OPTIONS,
              'disable-search': true,
              'selected-option': formValues.numberOfEmployees ? formValues.numberOfEmployees : `Select`,
              'validation-status': $helpers.getValidationStatus(`numberOfEmployees`),
            }),
            "on": {
              change: ev => $helpers.handleCompanySizeChange(ev.detail.item)
            },
          }));
          __jade_nodes = __jade_nodes.concat((formErrors.numberOfEmployees) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-error-msg': true
              },
            }, [__vjadeSafeCode(formErrors.numberOfEmployees)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['number-maus-select'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-field-label': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("How many monthly active users do you have?");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": __vjadeStringifyAttrsIfObj({
              options: JSON.stringify($helpers.MAU_SIZE_OPTIONS),
              'selected-option': formValues.numberOfMaus ? formValues.numberOfMaus : `Select`,
              'validation-status': $helpers.getValidationStatus(`numberOfMaus`),
            }),
            "on": {
              change: ev => $helpers.handleMauChange(ev.detail.item)
            },
          }));
          __jade_nodes = __jade_nodes.concat((formErrors.numberOfMaus) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'auth-form-error-msg': true
              },
            }, [__vjadeSafeCode(formErrors.numberOfMaus)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['signup-button'] = function(disableBack, signupText = `Sign Up`) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `sign-up-button`,
              disabled: waitingForResponse,
              size: `large`,
              theme: `primary`,
            }),
            "on": {
              click: $helpers.handleSignup
            },
            "class": {
              'auth-form-field-action-button': true
            },
          }, [__vjadeSafeCode(signupText)]));
          __jade_nodes = __jade_nodes.concat((!disableBack) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                size: `large`,
                theme: `tertiary`
              }),
              "on": {
                click: $helpers.handleBack
              },
              "class": {
                'auth-form-field-action-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Back");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['sign-in-with-google'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'data-client_id': $helpers.getSignInWithGoogleClientId(),
              'data-callback': 'handleGoogleCredentialResponse',
              'data-auto_prompt': `false`,
            }),
            "class": {
              'gid': true
            },
            "props": {
              id: 'g_id_onload'
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'data-type': `standard`,
              'data-size': `large`,
              'data-theme': `filled_blue`,
              'data-text': `continue_with`,
              'data-shape': `rectangular`,
              'data-logo_alignment': `left`,
              'data-width': 293,
            }),
            "class": {
              'g_id_signin': true
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-divider': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-divider-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("or sign up with email");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['already-a-user-footer'] = function(next) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const nextParam = next ? `?next=${encodeURIComponent(next)}` : ``;;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-footer': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Already a user? ");
            __jade_nodes = __jade_nodes.concat((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  href: `/login/${nextParam}`,
                  class: `mp-link`
                }),
                "style": {
                  'padding-left': `5px`
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Log in.");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this));
            __jade_nodes = __jade_nodes.concat("");;
            return __jade_nodes
          }).call(this));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['confirm-magic-link'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const email = formValues.email;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-copy-content': true,
            'center': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("We sent a verification email to");;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-copy-content-bold': true,
            'center': true
          },
        }, [__vjadeSafeCode(email)]));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['resend-magic-link-footer'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "on": {
            click: $helpers.sendRegistrationMagicLink
          },
          "class": {
            'auth-form-footer': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Not seeing the email? ");
            __jade_nodes = __jade_nodes.concat((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  class: `mp-link`
                }),
                "style": {
                  'padding-left': `5px`
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Resend");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this));
            __jade_nodes = __jade_nodes.concat("");;
            return __jade_nodes
          }).call(this));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const {
      InvitationStep
    } = require('./constants');;
    const uberUrl = require('./uber.png');;
    return {
      value: (h("form", {
        "attrs": __vjadeStringifyAttrsIfObj({
          name: `signup`,
          id: `signup-invited`
        }),
        "on": {
          submit: $helpers.handleFormSent,
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((step === InvitationStep.Default) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`is-uber`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'company-logo': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("img", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  src: uberUrl
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("h1", {
            "class": {
              'auth-form-title': true,
              'center': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Join Your Team");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-subtitle': true,
              'center': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Welcome to " + (formValues.company) + "’s org.");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form-subtitle': true,
              'center': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("" + (formValues.email) + " 🙂");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-user-list", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'max-icons-displayed': 4,
              users: $attr(`users-preview`) || [],
              'more-text': `team members`,
              'user-count-override': $attr(`users-total`),
              size: `small`,
              'style-override': `.more-text { font-size: 14px; } .users-list { justify-content: center; }`,
            }),
          }));
          __jade_nodes = __jade_nodes.concat(jade_mixins['sign-in-with-google'].call(this));
          __jade_nodes = __jade_nodes.concat(jade_mixins['terms-of-use-checkbox'].call(this));
          __jade_nodes = __jade_nodes.concat(jade_mixins['promo-checkbox'].call(this, $attr(`is-gdpr`)));
          __jade_nodes = __jade_nodes.concat(jade_mixins['signup-button'].call(this, true, `Join Team`));
          __jade_nodes = __jade_nodes.concat(jade_mixins['already-a-user-footer'].call(this, $attr(`next`)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['confirm-magic-link'].call(this));
          __jade_nodes = __jade_nodes.concat(jade_mixins['resend-magic-link-footer'].call(this));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "encodeURIComponent" in locals ? locals.encodeURIComponent : typeof encodeURIComponent !== "undefined" ? encodeURIComponent : undefined, "formErrors" in locals ? locals.formErrors : typeof formErrors !== "undefined" ? formErrors : undefined, "formValues" in locals ? locals.formValues : typeof formValues !== "undefined" ? formValues : undefined, "step" in locals ? locals.step : typeof step !== "undefined" ? step : undefined, "waitingForResponse" in locals ? locals.waitingForResponse : typeof waitingForResponse !== "undefined" ? waitingForResponse : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;